import * as i from 'types';
import * as React from 'react';
import DayPicker from 'react-day-picker';
import 'react-day-picker/lib/style.css';

import { FormField } from '../../FormField';
import { StyledCalendar } from './styled';
import { CalendarNavBar } from './CalendarNavBar';
import { CalendarCaption } from './CalendarCaption';

export const Calendar: React.FC<CalendarProps> = ({
  disabledDays, description, direction, name, onChange, label, error, value,
}) => {
  const disableWeekendsAndFridays = { daysOfWeek: [0, 5, 6] };
  const disableAllPastDays = { before: new Date() };
  const defaultDisabledDays = [disableAllPastDays, disableWeekendsAndFridays];

  return (
    <FormField {...{ name, label, description, direction, error }}>
      <StyledCalendar>
        <DayPicker
          onDayClick={onChange}
          selectedDays={value}
          firstDayOfWeek={1}
          showOutsideDays
          disabledDays={disabledDays || defaultDisabledDays}
          navbarElement={CalendarNavBar}
          captionElement={CalendarCaption}
          locale="nl"
        />
      </StyledCalendar>
    </FormField>
  );
};

export type CalendarProps =
  i.FormFieldProps
  & i.DefaultDateProps
  & {
    onChange: (date: Date) => void;
    value: Date;
  };
